<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      let pais = document.getElementsByClassName('pai')
      for (let pai of pais) {
        if (pai.id !== ('pai-' + e.target.id)) pai.classList.remove('open')
      }
      e.target.parentElement.classList.toggle('open')
    }
  }
}
</script>
<template>
  <router-link tag="li" class="nav-item nav-dropdown pai" :to="url" :id='"pai-" + id'  disabled>
    <div class="nav-link nav-dropdown-toggle" @click="handleClick" :id="id"><i :class="icon"></i> {{name}}</div>
    <ul class="nav-dropdown-items">
      <slot></slot>
    </ul>
  </router-link>
</template>



// WEBPACK FOOTER //
// navDropdown.vue?012c92b2